import { PrismicConfig } from '../prismicHelpers/PrismicAPI';
import  Prismic from "prismic-javascript";
import { prismicSlicesHelper, prismicSlicesContentRelationship } from "./prismic-slice-helpers/PrismicSliceHelpers";
//text helper
export const TextHelper = (object) => {
    if (object && object[0] && object[0].text && object[0].text.trim().length > 0) return object[0].text;
    return null
}
//number helper
export const NumberHelper = (object) => {
    if (object) return object;
    return null
}
//short information helper like date/uid/dropdown/color
export const SmallTextHelper = (object) => {
    if (object && object.length > 0) return object;
    return null
}
//url helper
export const UrlHelper = (object) => {
    if (object && object.url && object.url.length > 0) return object.url;
    return null
}
//rich text helper
export const ArrayHelper = (object) => {
    if (object && object[0] && object.length > 0 && Array.isArray(object)) return object;
    return null
}
//short information helper like date/uid/dropdown/color
export const EmbedHelper = (object) => {
    if (object) return object;
    return null
}
export const BooleanHelper = (object) => {
	if (object && typeof object == "boolean") return object;
	return null
}
//languagePrismic
export const LanguagePrismicHelper = (useGbDocument = false) => {
	const langGb = { lang : 'en-gb' };
	const langUs = {lang : 'en-us'};
	return useGbDocument ? langGb : localStorage.getItem('site_of_origin') === 'us' ? langUs : langGb;
}
//Initiate connection and return object where 'connection' is the api connection && 'result' is the json reponse from the query.
//List of 'type' parameters that can be used - https://prismic.io/docs/javascript/query-the-api/query-predicates-reference
//pass the returned data below to another helper to filter out the attributes needed.
//useGbDocument --- for special uses case where we share GB/UK documents for both uk and us pages. Use 'true' if this is the case otherwise do not pass parameter or use 'false'
//predicate --- Used to determine what query we are performing. Use 'at' for single items and 'in' for an array of items.
export async function PrismicDocumentHelper(type, name, useGbDocument, predicate, pageNumber = 1) {
	const languagePrismic = LanguagePrismicHelper(useGbDocument);
	const options = Object.assign(languagePrismic, { pageSize : 20, page: pageNumber});
	const obj = {};
	try {
		const res = await Prismic.api(PrismicConfig.apiEndpoint, {
			apiAccessToken: PrismicConfig.apiAccessToken,
		});
		obj.connection = res;
		switch (predicate) {
			case 'at':
				let dataAt = await res.query(Prismic.Predicates.at(type, name), languagePrismic);
				obj.result = dataAt.results;
				break;

			case 'in':
				let dataIn = await res.query(Prismic.Predicates.in(type, name), options);
				obj.pageDetails = dataIn;
				obj.result = dataIn.results;
				break;
		}
		return obj;
	} catch (err) {
		return { error: true };
	}
}

export async function PrismicSliceDataHelper(json){
    
    let data = prismicSlicesHelper(json.result);
    data = data.slices && data.slices.length > 0 ? await prismicSlicesContentRelationship(data.slices, json.connection) : null
    
    return data;
}


// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/PrismicHelpers.js